<script setup lang="ts">
import { RouterView, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
const router = useRouter()

function handleLogout() {
  auth.logout()
  router.push({ name: 'login' })
}
</script>

<template>
  <div class="h-full flex flex-col bg-slate-50">
    <header
      class="bg-white border-b border-slate-200 px-6 py-3 flex items-center justify-between shadow-sm"
    >
      <div class="flex items-center gap-3">
        <span class="inline-block w-2 h-6 bg-brand-600 rounded-sm"></span>
        <h1 class="text-base font-semibold text-slate-800">
          Kanban — Pablo Mendes
        </h1>
      </div>
      <div class="flex items-center gap-4">
        <template v-if="auth.isAuthenticated">
          <span class="text-sm text-slate-600">{{ auth.user?.name }}</span>
          <button
            type="button"
            class="text-xs text-slate-500 hover:text-slate-800 underline-offset-2 hover:underline"
            @click="handleLogout"
          >
            Sair
          </button>
        </template>
        <span class="text-xs text-slate-400 font-mono">v0.0.3</span>
      </div>
    </header>
    <main class="flex-1 overflow-hidden">
      <RouterView />
    </main>
  </div>
</template>
